<template>
  <div style="margin: 0 24px 12px;">
    <div v-if="showSearch" style="display: flex; justify-content: center; margin-bottom: 24px; background-color: #f5f7fa; padding: 24px 0;">
        <SearchUidOrPhone style="margin-right: 16px;" @confirm="getUserInfo($event)"/>
    </div>
    <div v-if="userForm && JSON.stringify(userForm) != '{}'">
      <el-descriptions title="客户信息" border :column="2" size="small">
        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="主人" >{{ userForm.name }}</el-descriptions-item>
        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="性别" >{{ userForm.sex == 1?'男':userForm.sex == 2?'女':'未知' }}</el-descriptions-item>
        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="手机号" >{{ userForm.phone }}</el-descriptions-item>
        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="门店" >{{ userForm.shopName}}</el-descriptions-item>
      </el-descriptions>

      <el-descriptions title="总余额" border :column="2" size="small" style="margin: 24px 0;">
        <template #title>
          <p>总余额：<span v-if="userForm.userWallet" style="color: #3a8ee6">{{ userForm.userWallet.balanceSumAll}}<span class="giveFont" v-if="userForm.userWallet.balanceSumAll">（{{userForm.userWallet.balanceSum}} + {{userForm.userWallet.balanceSumGive}}）</span></span></p>
        </template>
        <div v-if="userForm.userWallet">
          <el-descriptions-item label-class-name="my-label" class-name="my-item" label="500账户">{{ userForm.userWallet.balanceSumOne}}<span class="giveFont" v-if="userForm.userWallet.balanceSumOne">（{{ userForm.userWallet.balanceOne}} + {{userForm.userWallet.balanceOneGive}}）</span></el-descriptions-item>
          <el-descriptions-item label-class-name="my-label" class-name="my-item" label="1000账户">{{ userForm.userWallet.balanceSumTwo}}<span class="giveFont"  v-if="userForm.userWallet.balanceSumTwo">（{{ userForm.userWallet.balanceTwo}} + {{userForm.userWallet.balanceTwoGive}}）</span></el-descriptions-item>
          <el-descriptions-item label-class-name="my-label" class-name="my-item" label="1500账户">{{ userForm.userWallet.balanceSumThree}}<span class="giveFont"  v-if="userForm.userWallet.balanceSumThree">（{{ userForm.userWallet.balanceThree}} + {{userForm.userWallet.balanceThreeGive}}）</span></el-descriptions-item>
          <el-descriptions-item label-class-name="my-label" class-name="my-item" label="2500账户">{{ userForm.userWallet.balanceSumFour}}<span class="giveFont"  v-if="userForm.userWallet.balanceSumFour">（{{ userForm.userWallet.balanceFour}} + {{userForm.userWallet.balanceFourGive}}）</span></el-descriptions-item>
        </div>

      </el-descriptions>
      <el-form ref="formRef" :model="walletDetail" label-width="90px" label-position="left" :inline="true">
        <el-form-item label="充值账户：">
          <el-select v-model="balanceType" placeholder="请选择" style="width: 13em">
            <el-option v-for="item in balanceTypeArr" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="充值门店：">
          <el-select v-model="shopId" placeholder="请选择" style="width: 13em" @change="shopChange">
            <el-option v-for="item in shopIdArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="充值金额：">
          <el-input v-model="walletDetail.payNum" placeholder="请输入充值金额" style="width: 13em">
            <template #suffix>元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="负责人：">
          <el-select v-model="walletDetail.relationAdminId" placeholder="请选择" style="width: 13em">
            <el-option v-for="item in relationAdminIdArr" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <p style="color: #aaa; font-size: 12px;margin: -10px 0 16px 90px"><span style="color: red;">*允许输入负数，负数代表扣除对应的金额</span></p>
        <el-form-item label="赠送金额：">
          <el-input v-model="walletDetail.payGiveNum" placeholder="请输入赠送金额" style="width: 36.6em">
            <template #suffix>元</template>
          </el-input>
        </el-form-item>
        <p style="color: #aaa; font-size: 12px;margin: -10px 0 16px 90px"><span style="color: red;">*允许输入负数，负数代表扣除对应的金额</span></p>
        <el-form-item label="医疗金金额：">
          <el-input v-model="walletDetail.medicalBenefit" placeholder="请输入医疗金金额" style="width: 36.6em">
            <template #suffix>元</template>
          </el-input>
        </el-form-item>
        <p style="color: #aaa; font-size: 12px;margin: -10px 0 16px 90px"><span style="color: red;">*不允许输入负数</span></p>
        <el-form-item label="赠送项目：">
          <div style="display: flex">
            <div style="display: flex; align-items: center; cursor:pointer; margin-right: 24px;" @click="addProject(false)">
              <ElIcons name="CirclePlusFilled" color="#409EFF" :size="20"/>
              <el-button type="text" style="margin-left: 10px;">添加赠送系统项目</el-button>
            </div>
            <div style="display: flex; align-items: center; cursor:pointer;" @click="addProject(true)">
              <ElIcons name="CirclePlusFilled" color="#409EFF" :size="20"/>
              <el-button type="text" style="margin-left: 10px;">添加赠送自定义项目</el-button>
            </div>
          </div>
          <div v-if="projectGiveList.length > 0">
            <div v-for="(item,index) of projectGiveList" :key="index" style="display: flex; align-items: center; margin-top: 8px;">
              <div class="delBtn-d" v-if="item.preBookId > 0"><ElIcons name="SemiSelect" color="#ffffff" size="10"/></div>
              <div class="delBtn" v-else @click="delProject(index, item)"><ElIcons name="SemiSelect" color="#ffffff" size="10"/></div>
              <div style="display: flex; align-items: center; margin-right: 12px;">
                <span style="white-space: nowrap">服务类型：</span>
                <el-select :disabled="item.preBookId > 0" v-model="item.serviceType" placeholder="请选择" style="width: 7em;" @change="serviceTypeChange(item.serviceType, index)">
                  <el-option v-for="e in (item.isSpecial?serviceTypeSpecialList:serviceTypeList)" :key="e.serviceType" :label="e.name" :value="e.serviceType">
                  </el-option>
                </el-select>
              </div>
              <div style="display: flex; align-items: center">
                <span style="white-space: nowrap">项目：</span>
                <el-input  :disabled="item.preBookId > 0"  v-if="item.isSpecial" v-model="item.name" placeholder="请填写项目名称" style="width: 10.5em;flex: 1; margin-right: 8px"/>
                <el-select  :disabled="item.preBookId > 0"  v-else v-model="item.projectId" placeholder="请选择系统项目" style="width: 19em; flex: 1" @change="projectChange(item.projectId, index)">
                  <el-option v-for="e in item.projectList" :key="e.projectId" :label="e.name" :value="e.projectId">
                  </el-option>
                </el-select>
              </div>
              <div style="display: flex; align-items: center" v-if="item.isSpecial && item.serviceType !=6 ">
                <span style="white-space: nowrap">门店价：</span>
                <el-input  :disabled="item.preBookId > 0"  v-if="item.isSpecial" v-model="item.price" placeholder="价格" style="width: 4em;flex: 1;"/>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="付款截图：">
          <el-space wrap>
            <div class="img-box" v-for="(item, index) in imgArray" :key="item.id" @click="showImg(imgArray, index)">
              <el-image style="width: 80px; height: 80px;" fit="cover" :src="item.smallImg" ><template #error><div class="el-img-error">暂无图片</div></template></el-image>
              <div class="delIcon" @click.stop="delImg(index)"><ElIcons name="CloseBold" color="#ffffff"/></div>
            </div>
            <div class="add" @click="fileUpdate" v-if="imgArray.length < routeImageNum">
              <span>+</span>
            </div>
          </el-space>
          <input type="file" accept=".jp2,.jpe,.jpeg,.jpg,.png"  @change="fileChanged" ref="file" multiple="multiple" style="display:none;">
        </el-form-item>
        <el-form-item label="充值备注：">
          <el-input type="textarea" v-model="remark" :rows="4" placeholder="100字以内" style="width: 36.6em"/>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" style="text-align: center; margin-top: 8px;">
        <el-button @click.native="cancel" >取消</el-button>
        <el-button type="primary" v-loading="subLoading" :disabled="subLoading" @click="summit">确定</el-button>
      </div>
    </div>

  </div>

</template>

<script>
import {postFormData, getFormData, postJson, imgPostFormData} from "@/api/api"
import {payUserWallet, getOperateAdminsList, listProjectServiceType, getProjectTypeAndPrice, getSysGlobalParam, addWalletDetailImg, delWalletDetailImg } from "@/api/url";
import {add} from "@/assets/shared/util";
import { moneyReg, moneyRegNegative } from "@/assets/shared/reg-constant";
import SearchUidOrPhone from "@/components/SearchUidOrPhone";
import { ElLoading } from 'element-plus'
import ImgViewer from "@/assets/js/imageViewer";

export default {
  name: "UserFromDialog",
  components: {SearchUidOrPhone},
  props: {
    value: Object
  },
  data() {
    return {
      idx: this.value.idx,
      userForm: this.value.userForm,
      editState: this.value.editState,
      walletDetail: this.value.walletDetail,
      balanceType: this.value.walletDetail?this.value.walletDetail.balanceType:1,
      balanceTypeArr: [
        {label: '500账户', value: 1},
        {label: '1000账户', value: 2},
        {label: '1500账户', value: 3},
        {label: '2500账户', value: 4}
      ],
      shopId: '',
      shopIdArray: JSON.parse(sessionStorage.getItem('ownShopList')).filter(item => item.isEdit == 1),
      // payNum: '',
      // relationAdminId: '',
      // remark: '',
      // walletDetailId: 0,
      relationAdminIdArr: [],

      showSearch: this.value.showSearch?this.value.showSearch:false,

      remarkDefault: '此次已使用的赠送项目：\n' +
          '最后有剩余的赠送项目：',

      remark: this.value.walletDetail.remark?this.value.walletDetail.remark:'',

      subLoading: false,

      projectList: [],
      serviceTypeList: [],
      serviceTypeSpecialList: [],
      projectGiveList: this.value.walletDetail.projectGiveList?this.value.walletDetail.projectGiveList:[],

      imgArray: this.value.walletDetail.detailImgList?JSON.parse(JSON.stringify(this.value.walletDetail.detailImgList)):[],
      routeImageNum: 9,
      delImgIdArray: [],

      globalParam: {},

      firstState: true, //是否首次充值

    }
  },
  methods: {

    showImg(list, index) {
      let imgList = []
      list.map(item => {
        imgList.push(item.img)
      })
      ImgViewer.open({
        imgList: imgList,
        imgIndex: index
      })
    },


    //更改或添加
    fileUpdate() {
      this.$refs.file.click();
    },

    //选取图片
    fileChanged(e) {
      if(e.target.files[0]) {
        for(let item of e.target.files) {
          let windowURL = window.URL || window.webkitURL;
          let src = windowURL.createObjectURL(item);
          let obj = {'img': src, 'smallImg': src, 'files': item, 'id': 0};
          this.imgArray.push(obj);
        }
      }
      console.log(this.imgArray)
    },

    // 删除图片
    delImg(idx) {
      this.$confirm('确认删除图片').then(() => {
        if(this.imgArray[idx].id != 0) {
          // this.delImgIdFrom(this.imgArray[idx].id, idx);
          this.delImgIdArray.push(this.imgArray[idx].id)
        }
        this.imgArray.splice(idx,1);
      })
    },

    delImgIdFrom() {
      console.log('del')
      if(this.delImgIdArray.length > 0) {
        postFormData(delWalletDetailImg, {idArr: this.delImgIdArray}).then(data => {
          let {msg, code} = data
          if (code == 200) {
            this.$message({
              showClose: true,
              duration: 2000,
              message: msg,
              type: 'success'
            });
            // this.imgArray.splice(idx,1);
          }else {
            this.$message({
              showClose: true,
              duration: 2000,
              message: msg,
              type: 'warning'
            });
          }
        })
      }
    },

    addImgFrom(imgUploadList, walletDetailId) {
      this.$emit('close')
      const loadingInstance = ElLoading.service({
        lock: true,
        fullscreen: true,
        text: '图片上传中',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      let param = new FormData();
      param.append('id', this.userForm.id);
      param.append('walletDetailId', walletDetailId);
      for(let i = 0; i < imgUploadList.length; i++) {
        param.append('file' + i, imgUploadList[i].files);
      }
      imgPostFormData(addWalletDetailImg, param).then(data => {
        loadingInstance.close();
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: '图片上传成功',
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      }).catch(()=> {
        loadingInstance.close();
      })
    },


    cancel() {
      this.$emit("close");
    },
    summit() {
      console.log(this.firstState)
      // console.log(this.projectGiveList)
      // return false
      // if(this.remark == this.remarkDefault) {
      //   this.$message({
      //     showClose: true,
      //     duration: 2000,
      //     message: '备注信息为空',
      //     type: 'warning'
      //   });
      //   return false
      // }
      if(!this.walletDetail.payNum && !this.walletDetail.payGiveNum) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '金额不能为空',
          type: 'warning'
        });
        return false
      }

      if(this.walletDetail.payNum && this.walletDetail.payNum != 0 && !moneyRegNegative.test(this.walletDetail.payNum)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入正确的充值金额',
          type: 'warning'
        });
        return false
      }
      if(this.walletDetail.payGiveNum && this.walletDetail.payGiveNum != 0 && !moneyRegNegative.test(this.walletDetail.payGiveNum)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入正确的赠送金额',
          type: 'warning'
        });
        return false
      }

      let isSuper = JSON.parse(sessionStorage.getItem('isSuper'))
      let operateState = JSON.parse(sessionStorage.getItem('operateState'))
      if(isSuper == 0 && (operateState & 1024) != 1024 && this.walletDetail.payNum <= 0 && this.walletDetail.payGiveNum > 0) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入正确的赠送金额',
          type: 'warning'
        });
        return false
      }

      if(isSuper == 0 && (operateState & 1024) != 1024  && this.walletDetail.payNum > 0 && this.walletDetail.payGiveNum) {
        let rate = 100
        this.balanceTypeArr.map(item => {
          if(item.value == this.balanceType) {
            rate = item.giveRate
          }
        })
        console.log("rate:", rate)
        if(this.walletDetail.payGiveNum > Math.floor(this.walletDetail.payNum*rate/100)) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: '赠送金额已超过规定的上限，请联系上级负责人处理',
            type: 'warning'
          });
          return false
        }
      }

      if(!this.walletDetail.relationAdminId) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请选择负责人',
          type: 'warning'
        });
        return false
      }
      if(this.projectGiveList.length > 0) {
        for(let i=0; i<this.projectGiveList.length; i++) {
          if(!this.projectGiveList[i].projectId && !this.projectGiveList[i].isSpecial) {
            this.$message({
              showClose: true,
              duration: 2000,
              message: '请选择系统项目',
              type: 'warning'
            });
            return false
          }
          if(!this.projectGiveList[i].name && this.projectGiveList[i].isSpecial) {
            this.$message({
              showClose: true,
              duration: 2000,
              message: '请输入自定义项目',
              type: 'warning'
            });
            return false
          }
          if(!this.projectGiveList[i].price && this.projectGiveList[i].isSpecial && this.projectGiveList[i].serviceType != 6) {
            this.$message({
              showClose: true,
              duration: 2000,
              message: '请输入门店价',
              type: 'warning'
            });
            return false
          }
        }
      }
      if(this.walletDetail.payNum > 0 && this.imgArray.length == 0) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请先上传付款截图',
          type: 'warning'
        });
        return false
      }

      this.subLoading = true
      let param = {}
      param['id'] = this.userForm.id;
      param['balanceType'] = this.balanceType;
      param['payNum'] = this.walletDetail.payNum?this.walletDetail.payNum:0;
      param['payGiveNum'] = this.walletDetail.payGiveNum?this.walletDetail.payGiveNum:0;
      param['medicalBenefit'] = this.walletDetail.medicalBenefit?this.walletDetail.medicalBenefit:0;
      param['relationAdminId'] = this.walletDetail.relationAdminId;
      param['shopId'] = this.shopId;
      // if(this.remark != this.remarkDefault) {
      //   param['remark'] = this.remark;
      // } else if(this.editState) {
      //   param['remark'] = this.remark;
      // }
      // if(this.remark != this.remarkDefault) {
      //   param['remark'] = this.remark;
      // }
      param['remark'] = this.remark;
      param['walletDetailId'] = this.walletDetail.id?this.walletDetail.id:0;
      param['projectGiveList'] = this.projectGiveList;
      postJson(payUserWallet, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.delImgIdFrom()
          let imgUploadList = this.imgArray.filter(item => item.id == 0)
          if(imgUploadList.length > 0) {
            this.addImgFrom(imgUploadList, data.data)
          }else {
            this.$emit('confirm', param)
          }
          // this.$emit('confirm', param)
          this.$emit('close')
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.subLoading = false
      }).catch(()=>{
        this.subLoading = false
      })
    },

    shopChange(val) {
      this.relationAdminIdArr = []
      this.walletDetail.relationAdminId = ''
      this.getRelationAdminList(val)
      this.getProjectList(val)
    },

    getRelationAdminList (id) {
      getFormData(getOperateAdminsList, {id: id, loginState: 1}).then(data => {
        this.relationAdminIdArr = data.data
        // this.walletDetail.relationAdminId = this.relationAdminIdArr[0].adminId
      })
    },

    getUserInfo(e) {
      this.userForm = e
      this.userForm.userWallet.balanceSum = add([this.userForm.userWallet.balanceOne, this.userForm.userWallet.balanceTwo, this.userForm.userWallet.balanceThree, this.userForm.userWallet.balanceFour])
      this.userForm.userWallet.balanceSumGive = add([this.userForm.userWallet.balanceOneGive, this.userForm.userWallet.balanceTwoGive, this.userForm.userWallet.balanceThreeGive, this.userForm.userWallet.balanceFourGive])
      this.userForm.userWallet.balanceSumAll = add([this.userForm.userWallet.balanceSum, this.userForm.userWallet.balanceSumGive])
      this.userForm.userWallet.balanceSumOne = add([this.userForm.userWallet.balanceOne, this.userForm.userWallet.balanceOneGive])
      this.userForm.userWallet.balanceSumTwo = add([this.userForm.userWallet.balanceTwo, this.userForm.userWallet.balanceTwoGive])
      this.userForm.userWallet.balanceSumThree = add([this.userForm.userWallet.balanceThree, this.userForm.userWallet.balanceThreeGive])
      this.userForm.userWallet.balanceSumFour = add([this.userForm.userWallet.balanceFour, this.userForm.userWallet.balanceFourGive])
      let paySumAll = add([this.userForm.userWallet.paySumOne, this.userForm.userWallet.paySumTwo, this.userForm.userWallet.paySumThree, this.userForm.userWallet.paySumFour])
      if(paySumAll > 0 && this.userForm.firstPayWalletDetailId != this.walletDetail.id) {
        this.firstState = false
      }
      if(this.shopIdArray.some(e => e.id == this.userForm.shopId)) {
        this.shopId = this.userForm.shopId
      }else {
        this.shopId = this.shopIdArray[0].id
      }
      this.getRelationAdminList(this.shopId)
      this.getProjectList(this.shopId)
      this.getGlobalParam()
    },


    getServiceTypeList() {
      getFormData(listProjectServiceType).then(data => {
        if(data.code == 200) {
          this.serviceTypeSpecialList = data.data.filter(item => (item.serviceType != 3 && item.serviceType != 4 && item.serviceType != 7))
          this.serviceTypeList = data.data.filter(item => (item.serviceType == 1 || item.serviceType == 2 || item.serviceType == 7 || item.serviceType == 8 || item.serviceType == 9 || item.serviceType == 11 ))
        }
      })
    },

    getProjectList(shopId) {
      let param = {}
      param['shopId'] = shopId
      param['userId'] = this.userForm.id
      getFormData(getProjectTypeAndPrice, param).then(data => {
        if(data.code == 200) {
          this.projectList = data.data.filter(p => p.projectType != 2)
          if(this.idx > -1) {
            this.projectGiveList.map(item => {
              if(item.projectId == 0) {
                item.isSpecial = true
              }
              let list = []
              this.projectList.map(e => {
                if(item.projectId == e.projectId) {
                  item.price = e.price
                }
                if(item.serviceType == e.serviceType) {
                  list.push(e)
                }
              })
              item.projectList = list
            })
          }
        }
      })
    },


    addProject(special) {
      let obj = {
        id: 0,
        projectId: special?0:'',
        serviceType: 1,
        projectType: 1,
        price: '',
        name: '',
        isSpecial: special,
      }
      let list = []
      this.projectList.map(item => {
        if(item.serviceType == obj.serviceType) {
          list.push(item)
        }
      })
      obj.projectList = list
      this.projectGiveList.push(obj)
      console.log(this.projectGiveList)
    },

    delProject(idx, item) {
      this.projectGiveList.splice(idx, 1)
    },

    serviceTypeChange(type, idx) {
      if(!this.projectGiveList[idx].isSpecial) {
        let list = []
        this.projectList.map(item => {
          if(item.serviceType == type) {
            list.push(item)
          }
        })
        this.projectGiveList[idx].projectId = ''
        if(type == 3) {
          this.projectGiveList[idx].projectId = 0
        }
        this.projectGiveList[idx].projectList = list
      }
      this.projectGiveList[idx].projectType = 1
      if(type == 6) {
        this.projectGiveList[idx].projectType = 3
        this.projectGiveList[idx].price = 0
      }
    },

    projectChange(id, idx) {
      for(let i=0; i<this.projectGiveList[idx].projectList.length; i++) {
        if(id == this.projectGiveList[idx].projectList[i].projectId) {
          this.projectGiveList[idx].price = this.projectGiveList[idx].projectList[i].price
          this.projectGiveList[idx].projectType = this.projectGiveList[idx].projectList[i].projectType
        }
      }
    },

    getGlobalParam() {
      getFormData(getSysGlobalParam).then(data=> {
        let giveRateObj = {}
        if(this.firstState) {
          giveRateObj = data.data.userPayGiveRateFirst
        }else {
          giveRateObj = data.data.userPayGiveRate
        }
        this.balanceTypeArr[0].giveRate = giveRateObj.rateOne
        this.balanceTypeArr[1].giveRate = giveRateObj.rateTwo
        this.balanceTypeArr[2].giveRate = giveRateObj.rateThree
        this.balanceTypeArr[3].giveRate = giveRateObj.rateFour
        // console.log(this.balanceTypeArr)
      })
    },

  },
  mounted() {
    console.log(this.userForm)
    if(this.userForm && JSON.stringify(this.userForm) != '{}') {
      // this.userForm.userWallet.balanceSum = add([this.userForm.userWallet.balanceOne, this.userForm.userWallet.balanceTwo, this.userForm.userWallet.balanceThree, this.userForm.userWallet.balanceFour])
      this.userForm.userWallet.balanceSum = add([this.userForm.userWallet.balanceOne, this.userForm.userWallet.balanceTwo, this.userForm.userWallet.balanceThree, this.userForm.userWallet.balanceFour])
      this.userForm.userWallet.balanceSumGive = add([this.userForm.userWallet.balanceOneGive, this.userForm.userWallet.balanceTwoGive, this.userForm.userWallet.balanceThreeGive, this.userForm.userWallet.balanceFourGive])
      this.userForm.userWallet.balanceSumAll = add([this.userForm.userWallet.balanceSum, this.userForm.userWallet.balanceSumGive])
      this.userForm.userWallet.balanceSumOne = add([this.userForm.userWallet.balanceOne, this.userForm.userWallet.balanceOneGive])
      this.userForm.userWallet.balanceSumTwo = add([this.userForm.userWallet.balanceTwo, this.userForm.userWallet.balanceTwoGive])
      this.userForm.userWallet.balanceSumThree = add([this.userForm.userWallet.balanceThree, this.userForm.userWallet.balanceThreeGive])
      this.userForm.userWallet.balanceSumFour = add([this.userForm.userWallet.balanceFour, this.userForm.userWallet.balanceFourGive])

      let paySumAll = add([this.userForm.userWallet.paySumOne, this.userForm.userWallet.paySumTwo, this.userForm.userWallet.paySumThree, this.userForm.userWallet.paySumFour])
      if(paySumAll > 0 && this.userForm.firstPayWalletDetailId  != this.walletDetail.id ) {
        this.firstState = false
      }
      this.getGlobalParam()
    }

    if(this.walletDetail.shopId) {
      this.shopId = this.walletDetail.shopId
    }else {
      if(this.shopIdArray.some(e => e.id == this.userForm.shopId)) {
        this.shopId = this.userForm.shopId
      }else {
        this.shopId = this.shopIdArray[0].id
      }
    }

    this.getRelationAdminList(this.shopId)

    this.getServiceTypeList()
    this.getProjectList(this.shopId)


    // getFormData(getOperateAdminsList, {id: this.shopId}).then(data => {
    //   this.relationAdminIdArr = data.data
    // })

  }
}
</script>

<style scoped>
.delBtn {
  background-color: #bbbbbb;
  color: #ffffff;
  height: 18px;
  width: 18px;
  border-radius: 9px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  line-height: 10px;
  cursor: pointer;
  flex-shrink: 0;
  margin-right: 8px;
}
.delBtn:hover {
  background-color: red;
}
.delBtn-d {
  background-color: #bbbbbb;
  color: #ffffff;
  height: 18px;
  width: 18px;
  border-radius: 9px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  line-height: 10px;
  /*cursor: pointer;*/
  flex-shrink: 0;
  margin-right: 8px;
}
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
.img-box {
  width: 80px;
  height: 80px;
  position: relative;
}
.delIcon {
  background-color: rgba(0,0,0,0.8);
  width: 20px;
  height: 20px;
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
</style>
